<template>
  <div class="mapbox">
    <div class="bg-image">
      <div class="map-charts" id="priceChart"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'PriceDetail',

  // 1. 获取价格数据：采购/销售，采集日期（先使用mock data）
  // 2. 画两条折线图, y轴代表平均采购价格/平均销售价格, x轴采集日期

  data() {
    return {
      salePrice: [
        { price: 10, date: '3-1' },
        { price: 12, date: '3-2' },
        { price: 8, date: '3-3' },
        { price: 11, date: '3-4' },
        { price: 15, date: '3-5' }
      ],

      buyPrice: [
        { price: 7, date: '3-1' },
        { price: 6.5, date: '3-2' },
        { price: 7.6, date: '3-3' },
        { price: 8.1, date: '3-4' },
        { price: 11.4, date: '3-5' }
      ]
    }
  },

  mounted() {
    this.initPriceTrendChart()
  },

  methods: {
    // 获取销售价格数据

    // 获取采购价格数据

    //========== 处理图表 ==========
    initPriceTrendChart() {
      if (!this.salePrice || this.salePrice.length === 0) return

      if (!this.buyPrice || this.buyPrice.length === 0) return

      // 1.初始化Echarts实例
      const chartDom = document.getElementById('priceChart')

      const myChart = echarts.init(chartDom)

      window.addEventListener('resize', () => {
        myChart.resize()
      })

      // 2. 从salePrice, buyPrice提取图表需要的数据
      // x轴： 采集日期
      const xData = this.salePrice.map(item => item.date)

      // y轴：每天不同采集点的平均销售价格/平均采购价格
      const ySaleData = this.salePrice.map(item => item.price).reverse()
      const yBuyData = this.buyPrice.map(item => item.price).reverse()

      // 3. 配置参数
      const option = {
        title: {
          text: '采购/销售价格公示',
          left: 'center',
          textStyle: {
            color: '#ffffff',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },

        // tooltip: { trigger: 'axis' },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(20, 20, 20, 0.8)',
          borderColor: '#444',
          textStyle: { color: '#fff' },
          axisPointer: {
            type: 'shadow', // 或者是 'line'
            shadowStyle: { color: 'rgba(255,255,255,0.05)' }
          },
          formatter: params => {
            let res = `<div style="font-size:12px; color:#999; margin-bottom:4px;">${params[0].name}</div>`
            params.forEach(item => {
              res += `<div style="display:flex; justify-content:space-between; align-items:center; min-width:100px;">
                    <span>${item.marker} ${item.seriesName}</span>
                    <b style="color:#fff">￥${item.value}</b>
                  </div>`
            })
            return res
          }
        },

        grid: {
          top: '10%', // 距离顶部距离（给标题/单位留空间）
          left: '3%', // 距离左侧距离
          right: '8%', // 距离右侧距离
          bottom: '5%', // 距离底部距离
          containLabel: true // 包含坐标轴标签在内进行计算
        },

        xAxis: {
          type: 'category',
          data: xData,
          name: '日期',
          boundaryGap: true,
          nameTextStyle: { color: 'rgba(255,255,255,0.5)', fontSize: 16 },
          //坐标轴线和标签颜色
          axisLabel: { color: 'rgba(255,255,255,0.7)', fontSize: 18 },
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' },
            show: true,
            symbol: ['none', 'arrow'], // [起点, 终点] 箭头
            symbolSize: [8, 12], // [宽, 高]
            symbolOffset: [0, 10] // 箭头偏移量
          }
        },

        yAxis: {
          type: 'value',
          name: '￥/斤',
          nameTextStyle: { color: 'rgba(255,255,255,0.5)', fontSize: 16 },
          axisLabel: { color: 'rgba(255,255,255,0.7)', fontSize: 18 },
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' },
            show: true,
            symbol: ['none', 'arrow'], // [起点, 终点] 箭头
            symbolSize: [8, 12], // [宽, 高]
            symbolOffset: [0, 10] // 箭头偏移量
          },

          // 分割线颜色淡一点
          splitLine: false
        },

        legend: {
          data: ['销售价', '采购价'], // 绑定series.name
          icon: 'circle', //图例样式
          top: 40,
          right: 40,
          orient: '',
          textStyle: { color: '#ccc' },
          itemWidth: 18,
          itemHeight: 14
        },

        series: [
          {
            name: '销售价',
            type: 'line',
            data: ySaleData,
            // smooth: true,
            // 区域填充颜色
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(67, 233, 123, 0.3)' },
                { offset: 1, color: 'rgba(0, 210, 255, 0)' }
              ])
            },
            itemStyle: { color: '#43e97b' }, // 线条颜色
            lineStyle: {
              width: 3
            },
            symbolSize: 2,
            // 柱子顶部数值标签
            label: {
              show: true, // 是否显示数值
              position: 'top', // 相对点的位置：'top' / 'bottom' / 'left' / 'right' / 'inside'
              distance: 10, // 距离原点（数据点）的距离
              color: '#43e97b', // 文字颜色
              fontSize: 14, // 字体大小
              fontWeight: 'bold', // 字体粗细：'normal' / 'bold' / 'bolder'
              fontFamily: 'Arial', // 字体系列

              // 格式化函数：最强大的功能，可以自定义显示内容
              // {c} 代表数据值，{b} 代表类目名（日期），{a} 代表系列名
              formatter: '{c} 元',

              // 样式修饰
              //   backgroundColor: 'rgba(0,0,0,0.3)', // 给文字加个半透明背景
              padding: [4, 8], // 背景内边距 [上, 右, 下, 左]
              borderRadius: 4, // 背景圆角

              // 视觉引导（防止重叠）
              minMargin: 20 // 标签之间的最小间距
            }
          },
          {
            name: '采购价',
            type: 'line',
            data: yBuyData,
            itemStyle: { color: '#00d2ff' },
            lineStyle: { width: 3, shadowColor: 'rgba(0, 210, 255, 0.4)', shadowBlur: 10 },
            // 区域填充颜色
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0, 210, 255, 0.2)' },
                { offset: 1, color: 'rgba(0, 210, 255, 0)' }
              ])
            },
            symbolSize: 2,
            // 柱子顶部数值标签
            label: {
              show: true, // 是否显示数值
              position: 'bottom', // 相对点的位置：'top' / 'bottom' / 'left' / 'right' / 'inside'
              distance: 10, // 距离原点（数据点）的距离
              color: '#00d2ff', // 文字颜色
              fontSize: 14, // 字体大小
              fontWeight: 'bold', // 字体粗细：'normal' / 'bold' / 'bolder'
              fontFamily: 'Arial', // 字体系列

              // 格式化函数：最强大的功能，可以自定义显示内容
              // {c} 代表数据值，{b} 代表类目名（日期），{a} 代表系列名
              formatter: '{c} 元',

              // 样式修饰
              //   backgroundColor: 'rgba(0,0,0,0.3)', // 给文字加个半透明背景
              padding: [4, 8], // 背景内边距 [上, 右, 下, 左]
              borderRadius: 4, // 背景圆角

              // 视觉引导（防止重叠）
              minMargin: 20 // 标签之间的最小间距
            }
          }
        ]
      }

      // 4. 绘图
      myChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.mapbox {
  height: 100%;
  padding: 16px;
}

.bg-image {
  height: 100%;
  width: 100%;
}

.map-charts {
  height: 100%;
  width: 100%;
}
</style>
